import type { InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetDeployment =
  ApiClient['v1']['workspaces'][':workspaceId']['fleets'][':fleetId']['deployments'][':deploymentId']['$get'];
export type DeploymentResponse = InferResponseType<GetDeployment, 200>;

export function useDeployment(
  workspaceId: number,
  fleetId: number,
  deploymentId: number,
  options?: { shouldFetch?: boolean }
) {
  const shouldFetch = options?.shouldFetch ?? true;
  return useFetch<DeploymentResponse>(
    shouldFetch ? `workspaces/${workspaceId}/fleets/${fleetId}/deployments/${deploymentId}` : null,
    (client) =>
      client.v1.workspaces[':workspaceId'].fleets[':fleetId'].deployments[':deploymentId'].$get({
        param: {
          workspaceId: workspaceId.toString(),
          fleetId: fleetId.toString(),
          deploymentId: deploymentId.toString(),
        },
      })
  );
}
